import React from 'react';
import { useHistory } from 'react-router';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { closeJurisdictionsListAction, selectJurisdictionsAction } from '../../actions/proceedingActions';

import es from '../../lang/es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const JurisdictionList = () => {
    //Tomo los props
    const history = useHistory();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const selectedCenter = useSelector( state => state.proceeding.selectedCenter );
    const jurisdictions = useSelector( state => state.proceeding.jurisdictions );
    //Manejo la redirección
    const handleRedirect = jurisdiction => {
        //Llamo al dispatch
        dispatch( selectJurisdictionsAction(jurisdiction, history) );
    }
    //Manejo el cierre
    const handleClose = () => {
        //Llamo al dispatch
        dispatch( closeJurisdictionsListAction() );
    }
    //Render
    return (
        <Modal show={selectedCenter && true} onHide={handleClose} centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{ selectedCenter ? selectedCenter.description : null }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                {
                    jurisdictions ? (
                        jurisdictions.map(jurisdiction => (
                            <Col xs={12} key={`j${jurisdiction.id}`} className="mb-2">
                                <Button key={`jb${jurisdiction.id}`} block onClick={() => handleRedirect(jurisdiction)}>
                                    { jurisdiction.description }
                                </Button>
                            </Col>
                        ))
                    ) : null
                }
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} /> <strong>{ es.CLOSE.toUpperCase() }</strong>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default JurisdictionList;